module.exports = __webpack_public_path__ + "static/media/save.f638348b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Media/save.svg
// module id = 45
// module chunks = 0